import global from "../global";

// const baseUrl = "http://acts238games.com/qbbackend/";
// const baseUrl = "http://localhost/qbbackend/";
// const baseUrl = "https://acts238games.com/qbbackend/";
const baseUrl = global.config.apiBaseUrl;

//-----------------------------------------------------------------------------
// Switching to a named export below to get rid of eslint complaint...
// - Scott Lynn, Oct 2022
const backendAPI = {

  // TODO - Pass in usertoken string to backend for authentication - Scott Lynn Oct 2022

  //---------------------------------------------------------------------------
  get(url, return_status_code) {
    let requestUrl = url ? baseUrl + url : baseUrl;
    console.log('Fetching ' + requestUrl);
    return fetch(requestUrl, {
      mode: "cors",
      method: "GET",
    })
      .then((res) => {
        if (return_status_code === 1) {
          return res;
        } else {
          if (res.ok) {
            return res.json();
          } else {
            return res;
          }
        }
      })
      .then((res) => res)
      .catch((err) => {
        console.log("api error:", err);
      });
  },

  //---------------------------------------------------------------------------
  post(url, payload, return_status_code) {
    let requestUrl = url ? baseUrl + url : baseUrl;
    console.log('Posting ' + requestUrl);
    return fetch(requestUrl, {
      mode: "cors",
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (return_status_code === 1) {
          return res;
        } else {
          if (res.ok) {
            return res.json();
          } else {
            return res;
          }
        }
      })
      .then((res) => res)
      .catch((err) => {
        console.log("api error:", err);
      });
  },
};

export default backendAPI;
